import { Action, Dispatch } from 'redux';
import { fetchRolesForFiltersSuccess, fetchRolesMultiSelectSuccess } from './usersReducer';
import { ApiUser, roleApi, userApi, userBasicInternalApi } from '../apis';
import { showFeedback } from '../feedback/feedbackReducer';
import { UserModalValues } from './UserModal';
import { useQuery } from '@tanstack/react-query';
import { useMe } from '../organisation/useMe';

export const useQueryUsersBasic = () => {
  const { currentOrganisation } = useMe();

  const { data, isLoading } = useQuery({
    refetchOnMount: false,
    queryKey: ['usersBasic', currentOrganisation?.id],
    queryFn: () => userBasicInternalApi.findAllUsersBasicWithRoles(),
  });

  return { data, isLoading };
};

export const fetchRolesForMultiSelect =
  (organisationId?: number) =>
  async (dispatch: Dispatch): Promise<Action> => {
    const roles = await roleApi.findAllRoles({
      organisationId: organisationId,
    });
    return dispatch(fetchRolesMultiSelectSuccess(roles));
  };

export const fetchRolesForFilters =
  (organisationId?: number) =>
  async (dispatch: Dispatch): Promise<Action> => {
    const roles = await roleApi.findAllRoles({
      organisationId: organisationId,
      onlyAssignableToFilter: true,
    });
    return dispatch(fetchRolesForFiltersSuccess(roles));
  };

export const deactivateUser = async (userId: number) => {
  await userApi.deactivateUser({ userId });
};

export const activateUser = async (userId: number) => {
  await userApi.activateUser({ userId });
};

export const unlockUser = async (userId: number) => {
  await userApi.unlockUser({ userId });
};

export const reset2faForUser = async (userId: number) => {
  await userApi.reset2faForUser({ userId });
};

export const saveUser = (values: UserModalValues) => async (dispatch: Dispatch) => {
  const apiUser: ApiUser = {
    id: values.id,
    email: values.email,
    name: values.name,
    password: values.password || undefined,
    roles: values.roles || [],
    organisation: values.organisation,
  };
  let user: ApiUser;
  if (values.id !== undefined) {
    user = await userApi.updateUser({ apiUser });
    dispatch(showFeedback({ message: `User #${values.id} updated!`, success: true }));
  } else {
    user = await userApi.addUser({ apiUser });
    dispatch(showFeedback({ message: `User #${user.id} added!`, success: true }));
  }
  return user;
};
